import React from 'react';
import res1 from '../../assets/Partnerwithus/res1.png';
import res2 from '../../assets/Partnerwithus/res2.png';
import chart from '../../assets/Partnerwithus/chart.png';
import pathway from '../../assets/Partnerwithus/pathway.png';
import '../../styles/PartnerWithUs.css';

const images = [res1, res2, chart, pathway];

function PartnerVisualSequence() {
  return (
    <section className="partnerVisualSequence">
      {images.map((img, index) => (
        <img key={index} src={img} alt={`Visual ${index + 1}`} className="visualImage" />
      ))}
    </section>
  );
}

export default PartnerVisualSequence;
